import styled from "styled-components";

const ListaFormacoes = styled.div`
  color: #333;
  padding: 40px;
  background-color: #f5f5f5;
`;

export default ListaFormacoes;
